<template>
  <div class="home-content">
    <h-head v-if="!isMaxScreen"></h-head>
    <Head  v-if="isMaxScreen" ref="head" :backFn="back"></Head>
    <div :class="[isMaxScreen ? 'pc_privacyPolicy-container' : 'privacyPolicy-container']">
      <h1>{{ privacyPolicy.title }}</h1>

      <div v-for="(section, index) in privacyPolicy.sections" :key="index">
        <h2 class="h2">{{ section.title }}</h2>
        <div class="content" v-html="section.content"></div>

        <div v-if="section.subsections">
          <div v-for="(subsection, subIndex) in section.subsections" :key="subIndex">
            <h3 class="h3">{{ subsection.title }}</h3>
            <div class="content" v-html="subsection.content"></div>
          </div>
        </div>
      </div>

      <!-- <div class="content" v-html="privacyPolicy.footer"></div> -->
    </div>
    <bottom ref="bottom"></bottom>
  </div>
</template>

<script>
import { mapState } from 'vuex'

import hHead from '@/components/layout/head.vue';
import { lang } from '@/locales';
import { getChannelId } from '@/utils/channel';

import Bottom from '../../components/bottom';
import Head from '../../components/head'
import { atofflineDeData } from './atofflineDeData.js';
import { atonlineDeData } from './atonlineDeData.js';
import { atonlineEnData } from './atonlineEnData.js';
import { enData } from './enData.js';
import { esData } from './esData.js';
import { itData } from './itData.js';
export default {
  components: {
    hHead,
    Head,
    Bottom
  },
  data() {
    return {
      lang
      // privacyPolicy: {
      //   // ... the entire object from above
      // }
    };
  },
  computed: {
    ...mapState({
      isMaxScreen: state => state.isMaxScreen,
      channel() {
        // 使用封装的方法获取渠道 ID
        return getChannelId()
      }
    }),
    privacyPolicy() {
      // 根据渠道和语言返回对应的数据
      if (!this.channel || this.channel === '' || this.channel === '100000') {
        // 普通渠道：支持英语、西班牙语和意大利语
        if (this.lang == 'es') {
          return esData;
        } else if (this.lang == 'it') {
          return itData;
        }
        // 默认返回英语
        return enData;
      } else if (this.channel === '100070') {
        // 线上渠道：支持英语和德语
        if (this.lang == 'de') {
          return atonlineDeData;
        }
        // 线上渠道默认返回英语
        return atonlineEnData;

      } else if (this.channel === '100080') {
        // 线下渠道：只支持德语
        return atofflineDeData;
      }
      // 默认返回英语
      return enData;
    }
  }
};
</script>

<style scoped lang="less">
@media (min-width: 981px) {
  .home-content {
    width: 100%;
    min-height: 100%;
    background: #FFF;
    font-family: "PingFang SC";
    .pc_privacyPolicy-container{
      padding: 160px 0 120px;
      width: 1200px;
      margin: 0 auto;

      .content{
        font-size: 18px;
      }

      .h2{
        font-size: 28px;
      }

      .h3{
        font-size: 26px;
      }

      table{
        margin: 0 10px;
      }
    }
  }
}
@media (max-width: 980px) {
.home-content {
  width: 100%;
  min-height: 100%;
  background: #FFF;
  font-family: "PingFang SC";
  .privacyPolicy-container{
    padding:148px 30px 48px;

    .content{
      overflow-x: scroll;
    }
  }
}

}
</style>